import NotificationsPage from './Notifications';
const notificationsRoutes = {
    'w/:wallet_id/notifications': {
        path: 'w/:wallet_id/notifications',
        title: 'Notifications',
        component: NotificationsPage,
        auth: true,
        exact: true,
        showTab: false,
    },
};
export default notificationsRoutes;
